import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NeveBaseComponent } from './base/neve-base.component';
import { ValmetDnaService } from './valmet-dna.service';
import { NeveMeasurementsService } from './measurements/neve-measurements.service';
@NgModule({
  declarations: [ NeveBaseComponent ],
  imports: [ CommonModule ],
  exports: [ NeveBaseComponent ],
  providers: [ ValmetDnaService, NeveMeasurementsService ]
})
export class NeveModule {

}
